import { color } from "echarts";
import { useMemo } from "react";
import { LineChartData } from "Components/Charts/Line/Line";
import { useChartTheme } from "Components/Charts/useEChart";
import { useSelector } from "react-redux";
import {
  selectDashboardInspectionSubmissionWeekly,
  selectDashboardInspectionSubmissionWeeklyLoading,
} from "Redux/Dashboard/slice";

export const useDashboard = () => {
  const inspectionSubmission = useSelector(
    selectDashboardInspectionSubmissionWeekly,
  );
  const loading = useSelector(selectDashboardInspectionSubmissionWeeklyLoading);
  const { text, muted } = useChartTheme();

  const data = useMemo<LineChartData[]>(
    () => [
      {
        title: "This week",
        data: inspectionSubmission?.current_week?.map(
          (inspection) => inspection.count,
        ),
        itemColor: text,
        areaColor: [color.modifyAlpha(text, 1), color.modifyAlpha(text, 0)],
      },
      {
        title: "Last week",
        itemColor: muted,
        areaColor: [color.modifyAlpha(muted, 0.5), color.modifyAlpha(muted, 0)],
        data:
          inspectionSubmission?.previous_week?.map(
            (inspection) => inspection.count,
          ) || [],
      },
    ],
    [inspectionSubmission, text, muted],
  );

  const xAxisLabels = useMemo(() => {
    const points = Math.max(
      inspectionSubmission?.current_week?.length ?? 0,
      inspectionSubmission?.previous_week?.length ?? 0,
    );
    return Array.from({ length: points }, (_, i) => (i + 1).toString());
  }, [inspectionSubmission]);

  return { data, xAxisLabels, loading };
};
